import React from 'react';
import { styled } from 'linaria/react';
import { useBreakpoint } from '@mtsbank/ui-kit';
import { withTheme } from '@shared/lib';
interface Props {
  title: string;
  onClick?: () => void;
  modal?: boolean;
  cashback?: boolean;
  height?: number;
  icon?: React.ReactElement;
  startIcon?: React.ReactElement;
}
const ButtonDone = ({
  title,
  onClick,
  modal,
  icon,
  cashback,
  height,
  startIcon
}: Props) => {
  const {
    isMobile
  } = useBreakpoint();
  return <ButtonWrapper onClick={onClick} isMobile={isMobile} modal={modal} cashback={cashback} height={height}>
      <Text cashback={cashback}>
        {startIcon && startIcon}
        {title}
        <div>{icon && icon}</div>
      </Text>
    </ButtonWrapper>;
};
export default ButtonDone;
interface ButtonWrapperProps {
  isMobile: boolean;
  modal?: boolean;
  cashback?: boolean;
  height?: number;
}
const _exp = /*#__PURE__*/() => ({
  modal,
  theme
}) => modal ? theme.colors.state.alternativeSecondary : theme.colors.bg.tertiary;
const _exp2 = /*#__PURE__*/() => ({
  cashback
}) => cashback ? '8px 10px' : '18px 10px';
const _exp3 = /*#__PURE__*/() => ({
  height
}) => height ? `${height}px` : 'auto';
const _exp4 = /*#__PURE__*/() => ({
  modal,
  theme
}) => modal ? theme.colors.state.alternativeSecondaryHover : theme.colors.state.secondaryHover;
const _exp5 = /*#__PURE__*/() => ({
  modal,
  theme
}) => modal ? theme.colors.state.alternativeSecondaryTap : theme.colors.state.secondaryTap;
const _exp6 = /*#__PURE__*/() => ({
  disabled
}) => disabled ? 'none' : 'translateY(4px)';
const ButtonWrapper = withTheme(/*#__PURE__*/styled('button')({
  name: "ButtonWrapper",
  class: "b1qffqrc",
  propsAsIs: false,
  vars: {
    "b1qffqrc-0": [_exp()],
    "b1qffqrc-1": [_exp2()],
    "b1qffqrc-2": [_exp3()],
    "b1qffqrc-3": [_exp4()],
    "b1qffqrc-4": [_exp5()],
    "b1qffqrc-5": [_exp6()]
  }
}));
interface TextProps {
  cashback?: boolean;
}
const _exp7 = /*#__PURE__*/() => ({
  theme
}) => theme.font.family.MTSWide;
const _exp8 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.xxxs;
const _exp9 = /*#__PURE__*/() => ({
  theme
}) => theme.font.weight.bold;
const _exp0 = /*#__PURE__*/() => ({
  theme
}) => theme.font.lineHeight.xxxs;
const _exp1 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.primary;
const _exp10 = /*#__PURE__*/() => ({
  cashback
}) => cashback ? '4px 8px 0px 8px' : '0';
const Text = withTheme(/*#__PURE__*/styled('div')({
  name: "Text",
  class: "t1xkmxo0",
  propsAsIs: false,
  vars: {
    "t1xkmxo0-0": [_exp7()],
    "t1xkmxo0-1": [_exp8(), "px"],
    "t1xkmxo0-2": [_exp9()],
    "t1xkmxo0-3": [_exp0(), "px"],
    "t1xkmxo0-4": [_exp1()],
    "t1xkmxo0-5": [_exp10()]
  }
}));

require("./ButtonDone.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./ButtonDone.tsx");